export const zIndices = {
  adminPanel: 1100,
  extraPiece: 1000,
  boardShuffleIcon: 1000,
  pieceWhenPlayerOnIt: 900,
  playerOnBoard: 900,
  hideLabelsLink: 500,
}
